class UserModalService {
    constructor(
        $http,
        appConfig
    ) {
        'ngInject';

        this.$http = $http;
        this.appConfig = appConfig;
    }

    preRegisterUser(email, roleId, clientIds, customPermissions) {
        const data = {
            email: email,
            role_id: roleId,
            client_ids: clientIds,
            custom_permission_ids: customPermissions
        };
        return this.$http.post(`${this.appConfig.apiUrl}/users/pre-register/`, data);

    }

}

export default UserModalService;


// WEBPACK FOOTER //
// ./app/components/user-admin/pre-register-modal/pre-register-modal-service.js